<template>
    <div class="ba6-your-favorites-card">
        <div class="ba6-card">
            <div class="ba6-top ba-jc-sb">
                <span class="ba6-title">{{ t.your_favorites }}</span>
                <button v-if="hasFavoriteTools" class="ba6-btn" @click="openModal()">
                    <span class="ba6-btn-title">{{ t.add_favorites }}</span>
                    <span class="ba6-btn-icon ba-bg-blue1">+</span>
                </button>
            </div>
            <hr class="ba6-card-line">
            <div v-if="hasFavoriteTools" class="ba6-main-boxes">
                <a v-for="t,i in myFavoriteTools" :key="i" :href="t.route" class="ba6-blue-box">
                    <span class="ba6-box-icon ba-bg-blue1">
                        <builderall-icon code='builderall-logo'></builderall-icon>
                    </span>
                    <span class="ba6-box-title ba-color-black6" v-text="t.title"></span>
                </a>
            </div>
            <div v-else class="ba6-main-boxes">
                <button class="ba6-btn" @click="openModal()">
                    <span class="ba6-btn-title">{{ t.select_favorite_tools }}</span>
                    <span class="ba6-btn-icon ba-bg-blue1">+</span>
                </button>
            </div>
        </div>
        <div class="modal fade" id="modalFavoriteTools" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content modal_favorite_tools">
                    <div class="modal-body">
                        <div class="ba6-modal-body-top">
                            <h1>{{ t.select_favorite_tools }}</h1>
                            <span>{{ selectedItems.length }} / 3</span>
                        </div>
                        <h4 v-if="showMaximumMesage" v-text="t.deselect_one_tool"></h4>
                        <div class="ba6-modal-body-grid">
                            <div v-for="t,i in tools" :key="i" :for="t.slug" @click="handleClick(selectedItems.length > 2 && !selectedItems.includes(t.slug))">
                                <label :for="t.slug" v-html="t.title" :class="{'is-active-tool': selectedItems.includes(t.slug)}"></label>
                                <input type="checkbox" :id="t.slug" :disabled="selectedItems.length > 2 && !selectedItems.includes(t.slug)" v-model="selectedItems" :value="t.slug">
                            </div>
                        </div>
                        <div class="ba6-modal-body-footer">
                            <button class="ba-btn ba-lg ba-blue" @click="saveSelectedTools()">{{ t.ush_save }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ba6-your-favorites-card",
        props: ['view'],
        data() {
            return {
                myFavoriteTools: [],
                tools: [],
                selectedItems: [],
                showMaximumMesage: false,
                t: null
            }
        },
        created(){
            this.tools = this.view.tools;
            this.myFavoriteTools = this.view.favorite_tools;
            this.setCheckedTools();
            this.t = this.view.translations
        },
        methods: {
            openModal(){
                $('#modalFavoriteTools').modal('show');
            },
            saveSelectedTools(){
                let selectedTools = this.selectedItems;

                const headers = {
                    Accept: 'application/json',
                    Authorization: this.view.token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                };

                const formData = new URLSearchParams();
                formData.append('tools', JSON.stringify(selectedTools));

                fetch(this.view.routes.office_api+'/v1/favorite-tools', {
                    method: 'PUT',
                    headers: headers,
                    body: formData.toString()
                })
                    .then(response => response.json())
                    .then(result => {
                        alertMsg('success', this.t.favorite_tools_successfully_updated);
                        this.myFavoriteTools = [];
                        Object.keys(result.data).forEach((key) => {
                            const tool = this.tools.find((x) => x.slug === key);
                            if(tool){
                                this.myFavoriteTools.push(tool);
                            }
                        });
                    })
                    .catch(error => {
                        console.log('saveSelectedTools data error', error);
                    })
                    .finally(f => $('#modalFavoriteTools').modal('hide'))
            },
            setCheckedTools(){
                this.selectedItems = this.myFavoriteTools.map(y => y.slug);
            },
            handleClick(data){
                if(data){
                    this.showMaximumMesage = true;
                    alertMsg("error", this.t.select_maximum_3_tools);
                } else {
                    this.showMaximumMesage = false;
                }
            }
        },
        computed: {
            hasFavoriteTools(){
                return this.myFavoriteTools.length > 0;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/your-favorites/YourFavoritesCard.vue